"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSelectedOptions = exports.useSelectedOption = exports.useReferentialSelectedOptions = exports.getFlatOptions = void 0;
var React = _interopRequireWildcard(require("react"));
var _flatten = _interopRequireDefault(require("lodash/flatten"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const isGrouped = options => !!(options.length && options[0].hasOwnProperty("options"));
const getFlatOptions = options => isGrouped(options) ? (0, _flatten.default)(options.map(group => group.options)) : [...options];

/**
 * for a list or grouped list of options compatible with the alloy SelectBox,
 * returns the selected one based on its value. Memoized for performance.
 */
exports.getFlatOptions = getFlatOptions;
const useSelectedOption = (value, options) => {
  return React.useMemo(() => {
    if (!value || !options.length) {
      return undefined;
    }
    const flatOptions = getFlatOptions(options);
    const selectedOption = flatOptions.find(option => option.value === value);
    return selectedOption ? {
      ...selectedOption
    } : undefined;
  }, [value, options]);
};
exports.useSelectedOption = useSelectedOption;
const useSelectedOptions = (selectedValues, options) => {
  return React.useMemo(() => {
    if (selectedValues.length === 0) {
      return [];
    }
    const flatOptions = getFlatOptions(options || []);
    return selectedValues.reduce((acc, value) => {
      const selectedOption = flatOptions.find(option => option.value === value);
      return selectedOption ? [...acc, {
        ...selectedOption
      }] : acc;
    }, []);
  }, [selectedValues, options]);
};

// useMultiDropdown requires referential equality when comparing clicked menu items with the options
exports.useSelectedOptions = useSelectedOptions;
const useReferentialSelectedOptions = (selectedValues, options) => {
  return React.useMemo(() => {
    if (selectedValues.length === 0) {
      return [];
    }
    const flatOptions = getFlatOptions(options || []);
    return selectedValues.reduce((acc, value) => {
      const selectedOption = flatOptions.find(option => option.value === value);
      if (selectedOption) {
        acc.push(selectedOption);
      }
      return acc;
    }, []);
  }, [selectedValues, options]);
};
exports.useReferentialSelectedOptions = useReferentialSelectedOptions;
//# sourceMappingURL=useSelectedOption.js.map